// 移动端展开/收起功能
function initMobileExpand() {
    const btn = document.querySelector('.mobile-expand-btn');
    if (!btn) return;
    
    const isMobile = window.innerWidth <= 767;
    
    if (isMobile) {
        // 显示按钮并绑定事件
        btn.style.display = 'inline-block';
        
        // 移除旧的事件监听器
        const oldBtn = btn.cloneNode(true);
        btn.parentNode.replaceChild(oldBtn, btn);
        
        // 绑定新的事件
        oldBtn.addEventListener('click', function() {
            const container = this.closest('.mobile-text-container');
            if (container) {
                container.classList.toggle('expanded');
                this.textContent = container.classList.contains('expanded') 
                    ? 'Read Less' 
                    : 'Read More';
            }
        });
    } else {
        // 桌面端隐藏按钮并移除展开状态
        btn.style.display = 'none';
        const container = document.querySelector('.mobile-text-container');
        if (container) {
            container.classList.remove('expanded');
            btn.textContent = 'Read More';
        }
    }
}

// 防抖函数，防止频繁触发resize
function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

// 初始化
document.addEventListener('DOMContentLoaded', initMobileExpand);
window.addEventListener('resize', debounce(initMobileExpand, 250));
document.addEventListener('contextmenu', e => e.preventDefault());